import { useCallback, useState } from "react";

type Props = {
  onConfirm: () => void;
};

const useConfirmation = ({ onConfirm }: Props) => {
  const [isVisible, setIsVisible] = useState(false);

  const onClick = () => {
    setIsVisible(true);
  };

  const onConfirmed = useCallback(() => {
    setIsVisible(false);
    onConfirm();
  }, [onConfirm]);

  const onCancel = () => {
    setIsVisible(false);
  };

  return [isVisible, onClick, onConfirmed, onCancel] as const;
};

export default useConfirmation;
